import React from "react";
import "./LottieNavigation.css";

const LottieText = ({ title, subtitle }) => {
  return (
    <div className="lottie-text-container">
      <div className="lottie-text-title">{title}</div>
      <div className="lottie-text-subtitle">{subtitle}</div>
    </div>
  );
};

export default LottieText;
